<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11XWdqw/tc-custom/9781612007243.jpg?1716906251462" alt="This image is the cover for the book Operation Crusader, Die Wehrmacht im Kampf"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Operation Crusader, Die Wehrmacht im Kampf
      </h1>
      <p class="bookDescription body article font2">
        <b>A 1960s German perspective of the World War II battle in Libya and how the Allied and Axis commanders shaped the course of the action.</b><br/>  <br/> The port city of Tobruk, Libya, was besieged by German and Italian forces in April, 1941. Following an abortive attempt in June, the Allies made a second attempt in late November, when the Eighth Army launched Operation Crusader, aimed at destroying the Axis armored force then advancing. After several inconclusive engagements, the British 7th Armoured Division was defeated by the Afrika Korps at Sidi Rezegh. Erwin Rommel was then forced to withdraw his troops to the defensive line at Gazala, making the operation the first Allied victory over German land forces in World War II.<br/>  <br/> This account of the tank warfare during Operation Crusader in front of Tobruk in the fall of 1941 examines the roles of commanders in the battles of Operation Crusader, in particular the part of Rommel, who achieved some defensive successes during combat. As well as examining the part of commanders, it discusses the parameters of the battle: the terrain, weather, visibility, logistics, intelligence, and the forces involved. It then narrates the course of the battle, and the result.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Hermann Buschleb, David Dorondo
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Casemate US
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13427f1f